import Colors from '../../../config/Colors';

export default {
    tabBar: {
        backgroundColor: Colors.primary,
        width: 70,
        zIndex: 9999
    },

    tabBarContent: {
        flexDirection: 'column'
    },

    itemLogo: {
        display: 'flex',
        alignItems: 'center',
        paddingVertical: 24
    },

    logo: {
        width: 40,
        height: 40
    },

    itemAtivo: {
        color: Colors.warning
    },

    itemInativo: {
        color: Colors.primary
    },

    itemButtonAtivo: {
        padding: 14,
        borderRadius: 100,
        backgroundColor: Colors.lighter
    }
};
